<template>
  <div class="part-nine">
    <div class="title">
      <div class="title-first">官方资讯 最新动态</div>
      <div class="title-second">了解芸众科技最新动态</div>
    </div>
    <div class="trends-list">
      <div class="trends-list-item" v-for="(item, index) in trendsList" :key="index" >
        <div class="trends-list-item-top" :style="{ backgroundImage: `url(${item.bgImg})` }" @click="toUrl(item.middleUrl)">
          <div class="top-content">
            <div style="color:#fff;font-weight: 500;font-size:24px">{{ item.esTitle }}</div>
            <div style="color:#fff;font-size:24px;font-weight: 500;margin-top:20px">{{ item.title }}</div>
          </div>
        </div>
        <div class="trends-list-item-content">
          <div class="version-list-item" v-for="(items, indexs) in item.versionList" :key="indexs">
            <div class="create-time" >{{ items.data }}</div>
            <div :title="items.versionTitle" class="new-content" @click.stop="toUrl(items.url)">
              {{ items.versionTitle }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //芸众最新动态列表 
      trendsList: [
        {
          bgImg: require('../assets/image_1/617_2.png'),
          esTitle: 'PRODUCT UPDATES',
          title: '产品动态  |  更新升级',
          middleTitle: '功能 | 【聚合收银台】上线',
          middleDes: '生态联盟的平台方可以为N个商城提供聚合支付收银台能力。',
          middleUrl: 'https://www.yunzmall.com/plugins/shop_server/notice?class_id=29&i=10',
          versionList: [
            {
              data: '05-14',
              versionTitle: '优化 | 增加实名认证手机号检验能力',
              url: 'https://www.yunzmall.com/plugins/shop_server/articleContent/804?i=10'
            },
            {
              data: '04-30',
              versionTitle: '优化 | 企业管理平台增加【AI创作】入口预告',
              url: 'https://www.yunzmall.com/plugins/shop_server/articleContent/799?i=10'
            },
            {
              data: '04-22',
              versionTitle: '功能 | 【视频号超级成交】上线',
              url: 'https://www.yunzmall.com/plugins/shop_server/articleContent/798?i=10'
            },
            {
              data: '04-16',
              versionTitle: '优化 | 【AI创作】增加声音克隆CV版，声音复刻进入0元阶段',
              url: 'https://www.yunzmall.com/plugins/shop_server/articleContent/794?i=10'
            }
          ]
        },
        {
          bgImg: require('../assets/image_1/616_2.png'),
          esTitle: 'OPERATION TIPS',
          title: '运营干货  |  解决方案',
          middleTitle: '活动 | 11月活动升级！送直播IM服务',
          middleDes: '11月30日前，企业购买电商专业版赠送供应链中台厂家版。',
          middleUrl: 'https://www.yunzmall.com/plugins/shop_server/notice?class_id=25&i=10',
          versionList: [
            {
              data: '05-08',
              versionTitle: '功能运营 | 微信小店爆单，资金分佣合规无忧',
              url: 'https://www.yunzmall.com/plugins/shop_server/articleContent/801?i=10'
            },
            {
              data: '04-30',
              versionTitle: '功能运营 | 玩转微信小店，新商家也能订单不断',
              url: 'https://www.yunzmall.com/plugins/shop_server/articleContent/800?i=10'
            },
            {
              data: '04-17',
              versionTitle: '功能运营 | 小程序支付D1到账解决方案',
              url: 'https://www.yunzmall.com/plugins/shop_server/articleContent/795?i=10'
            },
            {
              data: '03-20',
              versionTitle: '方案PPT | 品牌私域矩阵营销方案',
              url: 'https://www.yunzmall.com/plugins/shop_server/articleContent/789?i=10'
            }
          ]
        },
        {
          bgImg: require('../assets/image_1/615_2.png'),
          esTitle: 'BUSINESS NEWS',
          title: '商业资讯  |  行业前线',
          middleTitle: '功能PPT | 《数据通系统聚合支付能力》',
          middleDes: '开放API接口，为平台服务商与生态联盟提供API服务分发、数据汇总归集、数据统一管理等能力',
          middleUrl: 'https://www.yunzmall.com/plugins/shop_server/notice?class_id=28&i=10',
          versionList: [
            {
              data: '05-14',
              versionTitle: '公告 | 抖音团购CPS下线通知',
              url: 'https://www.yunzmall.com/plugins/shop_server/articleContent/805?i=10'
            },
            {
              data: '03-12',
              versionTitle: '芸众 | 技术精英培训营第一期圆满结束',
              url: 'https://www.yunzmall.com/plugins/shop_server/articleContent/787?i=10'
            },
            {
              data: '02-13',
              versionTitle: '芸众 | 打造品牌私域矩阵，抢占2025年营销先机',
              url: 'https://www.yunzmall.com/plugins/shop_server/articleContent/776?i=10'
            },
            {
              data: '02-11',
              versionTitle: '公告 | 供应链中台报价单调整',
              url: 'https://www.yunzmall.com/plugins/shop_server/articleContent/775?i=10'
            },
          ]
        }
      ]
    };
  },

  methods: {
    toUrl(url) {
      window.open(url)
    }
  },

  components: {},
};

</script>
<style scoped>
.part-nine {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-bottom: 112px;
  background-image: url('../assets/part-nine-bg.png');
}

.title {
  margin-top: 56px;
}

.title-first {
  font-size: 40px;
  color: #000000;
  font-weight: bold;
  line-height: 1;
  margin-bottom: 30px;
}

.title-second {
  font-weight: 400;
  font-size: 24px;
  color: #404040;
  line-height: 1;
}

.trends-list {
  margin-top: 60px;
  display: flex;
}

.trends-list-item {
  background-color: #FFFFFF;
  width: 380px;
  border-radius: 4px;
  cursor: pointer;
}

.trends-list-item:nth-child(2) {
  margin: 0 18px
}
.create-time{
  width: 20%;
  font-weight: 400;font-size: 20px;color: #878787;flex-shrink: 0;
}
.trends-list-item:hover {
  /* box-shadow: 0px 13px 20px 1px rgba(117, 139, 185, 0.2); */
}

.trends-list-item-top {
  /* height: 179px; */
  /* width: 388px; */
  /* background-size: contain; */
  height: 184px;
  background-size: auto;
  background-repeat: no-repeat;
}

.top-content {
  padding: 45px 0 0 40px;
}


.trends-list-item-content {
  padding: 36px 22px 10px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
  border-radius: 0px 0px 8px 8px;
}

.version-list-item {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  line-height: 1;
}

.new-content {
  color: #333333;
  line-height: 1;
  cursor: pointer;
  width: 274px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 400;
  font-size: 18px;
  color: #091221;
}
</style>